//@flow
import {createSelector} from 'reselect'
import {useSelector} from "react-redux";
import { parseUser, parseUserMessage } from "../../types/user/parse";

const selectIsLoggedIn = createSelector(
    (state) => state.currentUser,
    (item) => item.get('isLoggedIn')
)

const selectLoginName = createSelector(
    (state) => state.currentUser,
    (item) => item.getIn(['data', 'loginName'])
)

const selectLoading = createSelector(
    (state) => state.currentUser,
    (item) => item.get('loading')
)

const selectLanguage = createSelector(
    (state) => state.currentUser,
    (item) => item.get('language')
)

const selectDecimalSeparator = createSelector(
    (state) => state.currentUser,
    (item) => item.get('decimalSeparator')
)

const selectThousandSeparator = createSelector(
    (state) => state.currentUser,
    (item) => item.get('thousandSeparator')
)

const selectDateFormat = createSelector(
    (state) => state.currentUser,
    (item) => item.get('dateFormat')
)

const selectTimeFormat = createSelector(
    (state) => state.currentUser,
    (item) => item.get('timeFormat')
)

const selectData = createSelector(
    [
        (state) => state.currentUser.get('data'),
        (state) => state.currentUser.get('language'),
    ],
    (item, language) => parseUser(item, language)
)

const selectToken = createSelector(
    (state) => state.currentUser,
    (item) => item.get('token')
)

const selectMessage = createSelector(
    (state) => state.currentUser.get('message'),
    (item) => parseUserMessage(item)
)

const useUserData = () => {
    const isLoggedIn = useSelector(selectIsLoggedIn)
    const loginName = useSelector(selectLoginName)
    const loading = useSelector(selectLoading)
    const language = useSelector(selectLanguage)
    const data = useSelector(selectData)
    const token = useSelector(selectToken)
    const decimalSeparator = useSelector(selectDecimalSeparator)
    const thousandSeparator = useSelector(selectThousandSeparator)
    const dateFormat = useSelector(selectDateFormat)
    const timeFormat = useSelector(selectTimeFormat)
    const message = useSelector(selectMessage)
    return {
        isLoggedIn,
        loginName,
        loading,
        message,
        language,
        data,
        token,
        decimalSeparator,
        thousandSeparator,
        dateFormat,
        timeFormat,
    }
}

export default useUserData